import { render } from "./LoadingHome.vue?vue&type=template&id=2ae239a7"
import script from "./LoadingHome.vue?vue&type=script&lang=js"
export * from "./LoadingHome.vue?vue&type=script&lang=js"

import "./LoadingHome.vue?vue&type=style&index=0&id=2ae239a7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__